import { CommonModule } from '@angular/common';
import { Component, Input, input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
	selector: 'lib-editable-field',
	imports: [CommonModule, FormsModule, ReactiveFormsModule],
	templateUrl: './editable-field.component.html',
	styleUrl: './editable-field.component.scss',
})
export class EditableFieldComponent {
	@Input() displayedValue = '';
	@Input() editMode = false;
	readonly customStyles = input<{
    [key: string]: string;
}>({});
}
